export default __webpack_public_path__ + "static/media/camer-icon.7b86cdc4.svg";